<template>
    <div class="main-icon-menu">
        <a class="logo logo-metrica d-block text-center" href="#">
            <span>
                <img alt="logo-small" class="logo-sm" src="@/assets/images/logo/s-stark-white.png">
            </span>
        </a>
        <nav class="nav">
            <span :key="menuDetail.title" v-for="menuDetail in menus">
                <span v-if="menuDetail.visibility==true">
                <a :class="{'active': activeMenu == menuDetail.title, 'isDisabled': confirmViews}"
                   :title="menuDetail.title"
                   @click="openMenuOf(menuDetail)"
                   class="nav-link"
                   data-placement="right"
                   data-toggle="tooltip-custom"
                   data-trigger="hover"
                   v-b-tooltip.hover.right
                >
                <i :class="'align-self-center '+menuDetail.icon+' menu-icon icon-dual font-20'"></i>
                </a>
                </span>
            </span>
        </nav><!--end nav-->

    </div><!--end main-icon-menu-->
</template>

<script>
    import {menu} from './menu';

    export default {
        name: 'IconsBar',
        props: {
            confirmViews: Boolean
        },
        data() {
            return {
                activeMenu: '',
                menus: null,
                actualMenu: null,
                hasChildren: true
            };
        },
        methods: {
            openMenuOf(menuDetail, isFirstTime = true) {
                if (menuDetail) {
                    this.activeMenu = menuDetail.title;
                    const val = menuDetail.childrens.length > 0;
                    this.$emit('openMenu', menuDetail, val);
                    if (menuDetail.router != this.$route.name && isFirstTime == true) {
                        this.$router.push({name: menuDetail.router});
                    }
                }
            },
            getMenusByRole(role) {
                return menu.filter(menuData => {
                    if (menuData.roles.includes(role)) {
                        if (menuData.childrens.length > 0) {
                            menuData.childrens = menuData.childrens.filter(child => child.roles.includes(role));
                        }
                        return menuData;
                    }
                    return false;
                });
            }
        },
        created() {
            this.menus = this.getMenusByRole(this.$store.getters.role);
            this.actualMenu = this.menus.find(d => this.$route.path.includes(d.router));
            this.openMenuOf(this.actualMenu, false);
        }
    };
</script>

<style scoped>
    .isDisabled {
        color: currentColor;
        cursor: not-allowed;
        opacity: 0.5;
        text-decoration: none;
        pointer-events: none;
    }
</style>
